import {ApplicationRef, ComponentFactoryResolver, ComponentRef, Directive, Input, TemplateRef} from "@angular/core";
import {VisBosComponent} from "../../../../visbos.component";
import {GenericModalComponent} from "../forms/generic-modal/generic-modal.component";

export interface GenericModalParameters {
  modalSize?: string;
  title?: string;
  isStatic?: boolean;
}

@Directive({
  selector: '[vbCreateModal]',
})
export class CreateModalDirective {

  @Input('vbCreateModal')
  modalTemplate: TemplateRef<any>;

  private rootViewRef;
  private modal: GenericModalComponent;

  constructor(private appRef: ApplicationRef, private componentFactoryResolver: ComponentFactoryResolver) {
    this.rootViewRef = (appRef.components[0].instance as VisBosComponent).rootViewRef;
  }

  createDialog(modalComponent: { new(): GenericModalComponent }): ComponentRef<GenericModalComponent> {
    this.rootViewRef.clear();

    let dialogComponentFactory =
      this.componentFactoryResolver.resolveComponentFactory(modalComponent);
    let dialogComponentRef = this.rootViewRef.createComponent(dialogComponentFactory);

    this.modal = dialogComponentRef.instance;

    this.modal.mainContentTmpl = this.modalTemplate;
    this.modal.closed.toPromise().then(() => {
      console.info("Destroy");
      dialogComponentRef.destroy();
    });

    dialogComponentRef.changeDetectorRef.detectChanges();

    return dialogComponentRef;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/dialogs/create-modal.directive.ts